<template>
  <div class="home-container1">
    <header data-role="Header" class="home-navbar-container">
      <Navbar />
    </header>
    <div class="glaszetten-section-separator1"></div>
    <div class="glaszetten-section-separator2"></div>
    <div class="glaszetten-container3">
      <div class="glaszetten-features">
        <h1 class="glaszetten-text">Glaszetten</h1>
        <div class="glaszetten-container4">
          <feature-card2
            :title="`${yearsOfExperience} jaar Ervaring`"
            :description="`Al ${yearsOfExperience} jaar ervaring. Erkend glaszetter.`"
            rootClassName="rootClassName"
          ></feature-card2>
          <feature-card2
            :title="`${yearsAsEntrepreneur} jaar zelfstandig ondernemer`"
            :description="`Al ${yearsAsEntrepreneur} jaar is Theo Brandt een zelfstandig ondernemer met genoeg ervaring voor elke klus!`"
            rootClassName="rootClassName3"
          ></feature-card2>
          <feature-card2
            title="Grote ruiten plaatsen"
            description="Theo Brandt is gespecialiseerd in het plaatsen van grote ruiten met kraan."
            rootClassName="rootClassName2"
          ></feature-card2>
          <feature-card2
            title="Glashandel, Renovatiewerk"
            description="Glashandel voor al uw glas. Renovatie werk"
            rootClassName="rootClassName1"
          ></feature-card2>
        </div>
      </div>
    </div>
    <div class="glaszetten-container5">
      <div class="glaszetten-gallery">
        <gallery-card1
          title="Plaatsing ruit Madam Tussaud"
          subtitle=" "
          imageSrc="/glaszetten/oud/plaatsing%20ruit%20madam%20tussaud%201via%20pels%20en%20joosten-1500h.jpeg"
          rootClassName="rootClassName"
        ></gallery-card1>
        <gallery-card1
          title="Begeleiden met hoogwerker"
          subtitle=" "
          imageSrc="/glaszetten/oud/begeleiden%20met%20hoogwerker-1500h.jpeg"
          rootClassName="rootClassName1"
        ></gallery-card1>
        <gallery-card1
          title="Geplaatst en afwerken"
          subtitle=" "
          imageSrc="/glaszetten/oud/geplaatst%20en%20afwerken-1500h.jpeg"
          rootClassName="rootClassName2"
        ></gallery-card1>
        <gallery-card1
          title="160Kg plaatsen met kraan."
          subtitle=" "
          imageSrc="/glaszetten/oud/160%20kg%20plaatsen%20met%20kraan%201-1500h.jpeg"
          rootClassName="rootClassName3"
        ></gallery-card1>
        <gallery-card1
          title="Kraan."
          subtitle=" "
          imageSrc="/glaszetten/oud/kraan%202-1500h.jpeg"
          rootClassName="rootClassName5"
        ></gallery-card1>
        <gallery-card1
          title="Structureel beglazen."
          subtitle=" "
          imageSrc="/glaszetten/oud/structureel%20beglazen%20flad%20gebouw%20noordwachter%20zaandam%20via%20pels%20en%20joosten-1500w.jpeg"
          rootClassName="rootClassName6"
        ></gallery-card1>
        <gallery-card1
          title="Noordwachter geplaatst."
          subtitle=" "
          imageSrc="/glaszetten/oud/noordwachter%20geplaatst-1500w.jpeg"
          rootClassName="rootClassName4"
        ></gallery-card1>
        <gallery-card1
          title="Opsteken "
          subtitle=" "
          imageSrc="/glaszetten/oud/effe%20opsteken%20!-1500h.jpeg"
          rootClassName="rootClassName8"
        ></gallery-card1>
        <gallery-card1
          title="Glas takelen met lier."
          subtitle=" "
          imageSrc="/glaszetten/oud/glas%20takelen%20met%20lier-1500h.jpeg"
          rootClassName="rootClassName7"
        ></gallery-card1>
      </div>
    </div>
    <div class="glaszetten-section-separator6"></div>
    <div class="glaszetten-section-separator7"></div>
    <div class="glaszetten-footer-container">
      <div class="glaszetten-footer">
        <Footer />
      </div>
    </div>
  </div>
</template>

<script>
import FeatureCard2 from "../components/feature-card2";
import GalleryCard1 from "../components/gallery-card1";
import Navbar from "../components/navbar.vue";
import Footer from "../components/footer.vue";

export default {
  name: "Glaszetten",
  props: {},
  components: {
    FeatureCard2,
    GalleryCard1,
    Navbar,
    Footer,
  },
  data() {
    return {
      currentYear: new Date().getFullYear(),
      startYear: 1989,
      startYearAsEntrepreneur: 1992,
    };
  },
  metaInfo: {
    title: "Glaszetten - Langglas",
    meta: [
      {
        property: "og:title",
        content: "Glaszetten - Langglas",
      },
    ],
  },

  computed: {
    yearsOfExperience() {
      return this.currentYear - this.startYear;
    },
    yearsAsEntrepreneur() {
      return this.currentYear - this.startYearAsEntrepreneur;
    },
  },
};
</script>

<style scoped>
.home-container1 {
  width: 100%;
  height: auto;
  display: flex;
  min-height: 100vh;
  align-items: center;
  flex-direction: column;
}
.home-navbar-container {
  width: 100%;
  display: flex;
  z-index: 100;
  position: absolute;
  box-shadow: 5px 5px 10px 0px #d4d4d4;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  background-color: #f5ff1c;
}
.home-navbar {
  width: 1550px;
  display: flex;
  max-width: auto;
  align-items: center;
  padding-top: var(--dl-space-space-tripleunit);
  padding-left: var(--dl-space-space-tripleunit);
  padding-right: var(--dl-space-space-tripleunit);
  flex-direction: row;
  padding-bottom: var(--dl-space-space-tripleunit);
}
.glaszetten-section-separator1 {
  width: 100%;
  height: 1px;
  display: flex;
  margin-top: var(--dl-space-space-tenunits);
  align-items: flex-start;
  flex-direction: column;
  background-color: var(--dl-color-gray-900);
}
.glaszetten-section-separator2 {
  width: 100%;
  height: 1px;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  background-color: var(--dl-color-gray-900);
}
.glaszetten-container3 {
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  background-color: #f1f1f1;
}
.glaszetten-features {
  width: 100%;
  display: flex;
  padding: 48px;
  max-width: 1400px;
  flex-direction: column;
}
.glaszetten-text {
  font-size: 3rem;
  margin-bottom: 48px;
}
.glaszetten-container4 {
  width: 100%;
  display: grid;
  grid-gap: 32px;
  grid-template-columns: 1fr 1fr;
}
.glaszetten-container5 {
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  background-color: #ffffff;
}
.glaszetten-gallery {
  width: 100%;
  display: grid;
  padding: 48px;
  grid-gap: var(--dl-space-space-unit);
  max-width: 1400px;
  grid-template-columns: 1fr 1fr 1fr;
}
.glaszetten-section-separator3 {
  width: 100%;
  height: 1px;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  background-color: var(--dl-color-gray-900);
}
.glaszetten-section-separator4 {
  width: 100%;
  height: 1px;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  background-color: var(--dl-color-gray-900);
}
.glaszetten-section-separator5 {
  width: 100%;
  height: 1px;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  background-color: var(--dl-color-gray-900);
}
.glaszetten-section-separator6 {
  width: 100%;
  height: 1px;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  background-color: var(--dl-color-gray-900);
}
.glaszetten-section-separator7 {
  width: 100%;
  height: 1px;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  background-color: var(--dl-color-gray-900);
}
.glaszetten-footer-container {
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  background-color: #e2e2e2;
}
.glaszetten-footer {
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  background-color: #e2e2e2;
}
.glaszetten-copyright-container {
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: center;
}
.glaszetten-icon5 {
  width: 24px;
  height: 24px;
  margin-right: var(--dl-space-space-doubleunit);
}
@media (max-width: 1600px) {
  .glaszetten-navbar {
    width: 100%;
  }
  .glaszetten-footer {
    justify-content: center;
  }
}
@media (max-width: 1200px) {
  .glaszetten-navbar {
    width: 100%;
  }
  .glaszetten-heading1 {
    margin-right: var(--dl-space-space-fourunits);
  }
  .glaszetten-links-container1 {
    width: auto;
    position: relative;
  }
  .glaszetten-link10 {
    width: auto;
    height: auto;
  }
  .glaszetten-link11 {
    width: auto;
    height: auto;
  }
  .glaszetten-link12 {
    width: auto;
    height: auto;
  }
  .glaszetten-link13 {
    width: auto;
    height: auto;
  }
  .glaszetten-link14 {
    width: auto;
  }
  .glaszetten-link15 {
    width: auto;
  }
}
@media (max-width: 991px) {
  .glaszetten-heading1 {
    text-align: center;
  }
  .glaszetten-links-container1 {
    width: 424px;
    display: none;
  }
  .glaszetten-link10 {
    width: auto;
    height: auto;
  }
  .glaszetten-link11 {
    width: auto;
    height: auto;
  }
  .glaszetten-link12 {
    width: auto;
    height: auto;
  }
  .glaszetten-link13 {
    width: auto;
    height: auto;
  }
  .glaszetten-link14 {
    width: auto;
    height: auto;
  }
  .glaszetten-link15 {
    width: auto;
    height: auto;
  }
  .glaszetten-burger-menu {
    display: flex;
  }
  .glaszetten-heading2 {
    text-align: center;
  }
  .glaszetten-gallery {
    grid-template-columns: 1fr 1fr;
  }
}
@media (max-width: 767px) {
  .glaszetten-navbar {
    position: relative;
  }
  .glaszetten-links-container1 {
    display: none;
  }
  .glaszetten-burger-menu {
    display: flex;
    padding: var(--dl-space-space-halfunit);
    margin-left: var(--dl-space-space-tripleunit);
    border-radius: var(--dl-radius-radius-radius4);
    background-color: var(--dl-color-gray-black);
  }
  .glaszetten-icon1 {
    fill: var(--dl-color-gray-white);
  }
  .glaszetten-features {
    padding-left: 32px;
    padding-right: 32px;
  }
  .glaszetten-container4 {
    grid-template-columns: 1fr;
  }
  .glaszetten-gallery {
    padding-left: 32px;
    padding-right: 32px;
  }
}
@media (max-width: 479px) {
  .glaszetten-burger-menu {
    margin-left: var(--dl-space-space-doubleunit);
  }
  .glaszetten-features {
    padding-top: 32px;
    padding-left: var(--dl-space-space-unit);
    padding-right: var(--dl-space-space-unit);
    padding-bottom: 32px;
  }
  .glaszetten-gallery {
    padding-top: 32px;
    padding-left: var(--dl-space-space-unit);
    padding-right: var(--dl-space-space-unit);
    padding-bottom: 32px;
  }
}
</style>
